import styles from './ComingSoon.module.css';

const ComingSoon = () => {
    return (
      <div className={styles.comingSoonContainer}>
        <h1 className={styles.comingSoonTitle}>🚕 RaveCabs is coming soon!</h1>
        <p className={styles.comingSoonDescription}>
          We’re building a smarter, faster, and more reliable taxi service for your city.
          Stay tuned for fast rides, seamless booking, and a great travel experience.
        </p>
        <p className={styles.comingSoonFooter}>
          Launching soon in Jaipur 🚀
        </p>
      </div>
    );
  };
  
export default ComingSoon;
  